import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { Environment } from 'dashboard/models/environment';
import { ReportRun } from 'dashboard/models/report-run';
import { ReportRunsFilterParams } from 'dashboard/redux/thunk-actions/report-runs';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';

export type ReportRunsActions =
  | Action<ReportRunsActionType.SetReportRuns, SetReportRunsPayload>
  | Action<ReportRunsActionType.SetReportRun, SetReportRunPayload>
  | Action<ReportRunsActionType.ClearReportRuns, ClearReportRunsPayload>
  | Action<ReportRunsActionType.SetCurrentPage, SetCurrentPagePayload>
  | Action<ReportRunsActionType.SetPageSize, SetPageSizePayload>
  | Action<ReportRunsActionType.SetFilters, SetFiltersPayload>
  | Action<ReportRunsActionType.SetSortParams, SetSortParamsPayload>;

export enum ReportRunsActionType {
  SetReportRuns = 'report_runs/SET_REPORT_RUNS',
  SetReportRun = 'report_runs/SET_REPORT_RUN',
  ClearReportRuns = 'report_runs/CLEAR_REPORT_RUNS',
  SetCurrentPage = 'report_runs/SET_CURRENT_PAGE',
  SetPageSize = 'report_runs/SET_PAGE_SIZE',
  SetFilters = 'report_runs/SET_FILTERS',
  SetSortParams = 'report_runs/SET_SORT_PARAMS',
}

interface SetReportRunPayload {
  reportRun: ReportRun;
  environment: Environment;
}

export function setReportRun(
  reportRun: ReportRun,
  environment: Environment,
): Action<ReportRunsActionType.SetReportRun, SetReportRunPayload> {
  return {
    payload: {
      reportRun,
      environment,
    },
    type: ReportRunsActionType.SetReportRun,
  };
}

interface SetReportRunsPayload {
  reportRuns: ReportRun[];
  environment: Environment;
  paginationParams: PaginationParams;
}

export function setReportRuns(
  reportRuns: ReportRun[],
  environment: Environment,
  paginationParams?: PaginationParams,
): Action<ReportRunsActionType.SetReportRuns, SetReportRunsPayload> {
  return {
    payload: {
      reportRuns,
      environment,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      paginationParams,
    },
    type: ReportRunsActionType.SetReportRuns,
  };
}

interface ClearReportRunsPayload {
  environment: Environment;
}

export function clearReportRuns(
  environment: Environment,
): Action<ReportRunsActionType.ClearReportRuns, ClearReportRunsPayload> {
  return {
    payload: {
      environment,
    },
    type: ReportRunsActionType.ClearReportRuns,
  };
}

interface SetCurrentPagePayload {
  currentPage: number;
}

export function setCurrentPage(
  currentPage: number,
): Action<ReportRunsActionType.SetCurrentPage, SetCurrentPagePayload> {
  return {
    payload: {
      currentPage,
    },
    type: ReportRunsActionType.SetCurrentPage,
  };
}

interface SetPageSizePayload {
  pageSize: number;
}

export function setPageSize(
  pageSize: number,
): Action<ReportRunsActionType.SetPageSize, SetPageSizePayload> {
  return {
    payload: {
      pageSize,
    },
    type: ReportRunsActionType.SetPageSize,
  };
}

interface SetFiltersPayload {
  filters: ReportRunsFilterParams;
}

export function setFilters(
  filters: ReportRunsFilterParams,
): Action<ReportRunsActionType.SetFilters, SetFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: ReportRunsActionType.SetFilters,
  };
}

interface SetSortParamsPayload {
  sortParams: SortParams;
}

export function setSortParams(
  sortParams: SortParams,
): Action<ReportRunsActionType.SetSortParams, SetSortParamsPayload> {
  return {
    payload: {
      sortParams,
    },
    type: ReportRunsActionType.SetSortParams,
  };
}
